import { Fragment, useContext, useEffect, useState } from "react";
import { OrderSummaryRowSkeleton } from "../../Skeleton/OrderSummaryRowSkeleton";
import { ImageWithDefault } from "../../Layout/Common/imageWithDefault";
import { LinkProductPage } from "../../Layout/Common/LinkProductPage";
import { ConvertToFloat, isValidArray } from "../../Layout/Common/common";
import { ItemReferenceInput } from "../../Layout/Common/itemReferenceInput";

export const OrderSummaryRow = ({ cartItem }) => {
  useEffect(() => {
  }, [cartItem]);

  return (
    <Fragment>
      <div className="order-summary-items">
        {cartItem && isValidArray(cartItem.cartItem) ? (
          <Fragment>
            {cartItem.cartItem.map((r, index) => (
              <div className="selected-products" key={index}>
                <div className="selected-products-img added-cartPro-img">
                  <ImageWithDefault src={r.image_th} alt={r.description} />
                </div>
                <div className="selected-products-info web-fill-width">
                  <h5>
                    <LinkProductPage productCode={r.prod_code} value={r.description} />
                  </h5>
                  <div className="added-cartPro-price">
                    <p>
                      <span>Code: {r.prod_code}</span> | Qty: {r.qty}
                    </p>
                    <p>
                      {r.total_ext && r.total_ext === "TBA" ? (
                        <span>TBA</span>
                      ) : (
                        <span style={{ color: "#000" }}>{`$ ${ConvertToFloat(r.total_ext)}`}</span>
                      )}
                    </p>
                  </div>
                  <ItemReferenceInput item={r} readOnly />
                </div>
              </div>
            ))}
          </Fragment>
        ) : (
          <OrderSummaryRowSkeleton />
        )}
      </div>
    </Fragment>
  );
};
